import { motion } from "framer-motion";
import { useEffect, useState } from "react";

type Props = {
  delay?: number;
};

export default function NotificationsOfferLoader({ delay = 10 }: Props) {
  const [start, setStart] = useState(false);

  useEffect(() => {
    setStart(true);
  }, []);

  return (
    <div className="absolute left-0 bottom-0 bg-white/20 w-full h-[0.125rem] overflow-hidden">
      {start && (
        <motion.div
          initial={{ width: "0%" }}
          animate={{ width: "100%" }}
          transition={{ duration: delay / 1000, ease: "linear" }}
          className="h-full bg-gradient-to-r from-transparent to-white rounded-r-sm"
        />
      )}
    </div>
  );
}
